import { render } from "./CustomerInfoForm.vue?vue&type=template&id=d124d698&scoped=true"
import script from "./CustomerInfoForm.vue?vue&type=script&lang=js"
export * from "./CustomerInfoForm.vue?vue&type=script&lang=js"

import "./CustomerInfoForm.vue?vue&type=style&index=0&id=d124d698&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d124d698"]])

export default __exports__